module.exports = "/static/images/footer-bg.jpg";